module.exports = __webpack_public_path__ + "img/edge_activites_motonautisme.c15c0946.svg";